import { getStepDocument } from '../utils';
//import useAutomation from '../../../automation';
//import { AUTOMATION_ACTION_TYPE } from '../../../automation';
import { useSelector, useDispatch } from 'react-redux';
import { getDataLinkPath } from '../../../page/utils';
import { deleteDoc, updateDoc, doc } from 'firebase/firestore';
import useDataLinkDatabase from '../../../database/datalink';
import { keyUpdatedAction } from '../../../../redux/actions/local';
import { logDocumentEvent } from '../utils';
//import useCloud from '../../../cloud';

const useRemove = () => {
  //const { deepDelete } = useCloud();
  //const { onDocumentAction } = useAutomation();
  const dispatch = useDispatch();
  const user = useSelector(state => state.User);
  const { dataLinks } = useSelector(state => state.DataLinks);
  const { getDb, getDatabaseId } = useDataLinkDatabase();

  const removeDocument = async ({
    page,
    sequence,
    step,
    documents,
    selections,
    local,
    data,
    params
  }) => {
    const pageDataLink = page.dataLinks.find(
      d => d.dataLinkId === step.deleteDocumentDataLinkId
    );

    if (!pageDataLink) {
      return {
        error: `sequence "${sequence.name}", step: ${step.name} cannot be processed because the data link with id ${step.deleteDocumentDataLinkId} set against the step cannot be found.`
      };
    }

    const contentType = pageDataLink.dataLink.contentType;

    const document = getStepDocument({
      selections,
      dataLinkId: step.deleteDocumentDataLinkId,
      documents
    });

    if (!document) {
      return {
        error: `data link "${step.deleteDocumentDataLinkId}" does not have a selected document that can be deleted by sequence "${sequence.name}", step: ${step.name}"`
      };
    }

    const path = getDataLinkPath({
      dataLink: pageDataLink.dataLink,
      documents,
      selections,
      user,
      local,
      dataLinks,
      data,
      params
    });

    const id = document.id;
    const db = getDb(pageDataLink.dataLinkId);
    const databaseId = getDatabaseId(pageDataLink.dataLinkId);

    if (contentType?.virtualDelete) {
      await updateDoc(doc(db, path, id), { deleted: true }, id);
      /*
      await onDocumentAction({
        action: AUTOMATION_ACTION_TYPE.RECORD_DELETED,
        id,
        contentType,
        path: `${path}/${id}`
      });
      */
    } else {
      await deleteDoc(doc(db, path, id));
      /*await deepDelete({
        collectionPath: path.replace(`/${id}`),
        id
      });*/
    }

    if (step.logDocumentEvent) {
      await logDocumentEvent({
        db,
        databaseId,
        contentTypeName: contentType.type,
        documentAction: 'onDocumentDeleted',
        documentId: id,
        path: `${path}/${id}`,
        before: document,
        source: `actions.steps.remove:\r\npage.id: ${page.id}\r\npage.name: ${page.name}\r\nsequence.id: ${sequence.id}\r\nsequence.name: ${sequence.name}\r\nstep.id: ${step.id}\r\nstep.name: ${step.name}`
      });
    }

    // only required since we are running this step in a closure and need other steps to be able to see deletes
    // before redux completes updates
    const index = documents[pageDataLink.dataLinkId]?.documents?.findIndex(
      d => d.id === id
    );
    if (index > -1) {
      documents[pageDataLink.dataLinkId]?.documents?.splice(index, 1);
    }

    /*
    await onDocumentAction({
      action: AUTOMATION_ACTION_TYPE.RECORD_DELETED,
      id,
      contentType,
      path: `${path}/${id}`
    });
    */

    /*
      remove the document from search results
    */
    if (
      local &&
      step.searchLocalStoreKeyName?.trim().length > 0 &&
      local[step.searchLocalStoreKeyName] !== undefined &&
      Object.keys(local[step.searchLocalStoreKeyName].pages).length > 0
    ) {
      const search = { ...local[step.searchLocalStoreKeyName] };
      let hasChanges = false;

      Object.keys(search.pages).forEach(pageName => {
        let index = search.pages[pageName].results.findIndex(d => d.id === id);
        if (index > -1) {
          search.pages[pageName].results.splice(index, 1);
          search.pages[pageName].count -= 1;
          search.count -= 1;
          hasChanges = true;
        }
        index = search.page.results.findIndex(d => d.id === id);
        if (index > -1) {
          search.page.results.splice(index, 1);
          search.page.count -= 1;
          search.count -= 1;
          hasChanges = true;
        }
      });

      if (hasChanges) {
        dispatch(keyUpdatedAction(step.searchLocalStoreKeyName, search));
      }
    }

    return { success: true };
  };

  return {
    removeDocument
  };
};

export default useRemove;
